import React from "react"
import QuestionPage from "../../templates/seo-collection/QuestionPage"

const Page = () => <QuestionPage destinationKey="mauritius" questionKey="fourSeasonsVsOneOnly" locale="fr" />

export default Page
